import { FunctionalComponent, h } from 'preact';

const CheckMarkIcon: FunctionalComponent = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <title>Group 3</title>
      <defs>
        <path
          d="M3.53623364,7.75586854 L0.266400843,4.75952008 C0.0958479367,4.60358349 0,4.39187701 0,4.17110068 C0,3.95032435 0.0958479367,3.73861786 0.266400843,3.58268127 C0.621619447,3.25717267 1.19543412,3.25717267 1.55065272,3.58268127 L4.18291366,5.98643714 L10.4493342,0.244131455 C10.8045528,-0.0813771518 11.3783674,-0.0813771518 11.733586,0.244131455 C12.0888047,0.569640063 12.0888047,1.09546166 11.733586,1.42097027 L4.82048551,7.75586854 C4.47437508,8.08137715 3.89145224,8.08137715 3.53623364,7.75586854 Z"
          id="path-1"
        />
      </defs>
      <g id="[EUD-935]-Language-Selector" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Language-Switch---open" transform="translate(-975.000000, -145.000000)">
          <g id="atom/language-switch-new-copy-4" transform="translate(864.000000, 132.000000)">
            <g id="Language" transform="translate(0.000000, 4.000000)">
              <g id="Group-3" transform="translate(111.000000, 9.000000)">
                <rect id="Rectangle" fill="transparent" x="0" y="0" width="24" height="24" />
                <g id="↳-Color" transform="translate(6.000000, 8.000000)">
                  <mask id="mask-2" fill="white">
                    <use xlinkHref="#path-1" />
                  </mask>
                  <g id="icon/action/check_circle_24px" fillRule="nonzero" />
                  <rect
                    id="Rectangle"
                    fill="#303030"
                    mask="url(#mask-2)"
                    x="-4.44444444"
                    y="-5.55555556"
                    width="20"
                    height="20"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default CheckMarkIcon;
